
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class TooltipSidebar extends Vue {
  @Prop({ required: true }) title!: string;

  @Prop({ required: true }) description!: string;

  private close(): void {
    this.$emit('close');
  }
}
